export default "__VITE_ASSET__CM7gerHE__"